import React from "react";
import {injectIntl} from "react-intl";
import AisleLabel from "./AisleLabel";
import ColumnLabel from "./ColumnLabel";

const ColumnLabelRow = (props) => {

    const {labelList} = props;

    return (
        <div style={{ display: "flex"}}>
            <AisleLabel/>
            {labelList.map(label => (
                <ColumnLabel {...{label}}/>
            ))}
        </div>
    )
}

export default injectIntl(ColumnLabelRow);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/ColumnLabelRow.js